
const window = require('window');

require('jquery');
require('jquery.inputmask');


const Inputmask = window.Inputmask;

Inputmask.extendDefaults({
	showMaskOnHover: false,
	noValuePatching: true,
});

module.exports = Inputmask;

